// extracted by mini-css-extract-plugin
module.exports = {"text":"_3cE1AYXN","logo":"_2gavTtic"};